import { Component, OnInit, Input } from '@angular/core';
import { StatusService } from 'app/services/status.service';
import { CarrierService } from 'app/services/carrier.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { AuthWebService } from 'app/services/authweb.service';
import { error } from 'protractor';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'list-accounts',
  templateUrl: './list-accounts.component.html',
  styleUrls: ['./list-accounts.component.css']
})
export class ListAccountsComponent implements OnInit {

  @Input('ctrlData') ctrlData: any;
  flags = { flagAN: 1, flagNM: 1, flagLU: 1, flagCT: 1, flagST: 1, flagDS: 1 };
  ranks = { flagAN: 1, flagNM: 2, flagLU: 3, flagCT: 4, flagST: 5, flagDS: 6 };
  sortLabels = { flagAN: "AccountNumber", flagNM: "Name", flagLU: "LeadUser", flagCT: "CarrierType", flagST: "Status", flagDS: "DateSubmitted" };
  direction: boolean = false;
  criteria = "DateSubmitted";
  rankCtrl: number = 6;
  accounts: any = [];
  isLoading: Boolean = false;
  message: string = 'Loading carrier accounts, please wait...';
  statuses: any = [];
  keyword: any = {};
  currentPage = 1;
  isEmpty: boolean = false;
  pageSize: number = 10;
  accountStatus2: number;
  accountStatus3: number;
  count: number = 0;
  disabled = false;
  ShowFilter = false;
  limitSelection = false;
  selectedItems: any = [];
  dropdownSettings: any = {};
  carrierNumber: string;
  carrierName: string;
  processFlag:boolean=false;
  currentUserName : string = '';

  constructor(private msg: ToastrService, private authWebService: AuthWebService, private statusService: StatusService, private carrierService: CarrierService, public utility: UtilityServiceService,
    private router:Router, private activateRoute:ActivatedRoute) { }

  ngOnInit() {
    this.currentUserName = this.authWebService.userData.User.UserName;
    if(this.router.url.indexOf('carrier')>0){
      let  id:any=this.activateRoute.params['_value'].id;
      this.utility.carrierId=id;
      this.processFlag=true;
    }
    this.initKeyword();
    this.retrieveDefaultStatuses();
    this.utility.page = 1;
    this.loadStatuses();
    this.InitMultiselect();
    //this.testEvo();
  }

  loadStatuses = () => {
    this.statusService.statusesDDL().subscribe((result:any) => {
      this.statuses = result.map(row => {
        return { id: row.id, desc: row.desc };
      });
      this.loadAccounts(this.currentPage, this.pageSize);
    });

  }

  loadAccounts = (page: number = 1, pageSize: number = 10) => {
    this.isLoading = true;
    this.carrierService.searchCarrierAccounts(this.keyword, page, pageSize, this.rankCtrl, this.direction).subscribe((result:any) => {
      this.accounts = result.Accounts;
      //console.log(this.accounts);
      this.count = result.Count;
      this.onExcuteSort(this.rankCtrl);
      this.isLoading = false;
      if(this.processFlag){
        let data:any=this.accounts.filter((map)=>{return map.Id==this.utility.carrierId});
        if(data!=null && data.length>0){
          this.onProcess(2,data[0]);
        }else{
          if(this.ctrlData.data!=null){
            if(this.ctrlData==undefined || Object.keys(this.ctrlData.data).length==0){
             if(this.utility.carrierObject!=null){
              this.ctrlData=this.utility.carrierObject;
              this.ctrlData.id=this.utility.carrierId;
             }
            }
            this.onProcess(2,this.ctrlData.data);
          }
        }
      }
    }, error => {
      //console.log('Error occured: ' + error);
      this.isLoading = false;
    });

  }

  isCompleted = (obj: any) => { }
  onAdministration = (obj: any) => { }


  retrieveDefaultStatuses = () => {
    if (this.authWebService.userData) {
      this.accountStatus2 = + this.authWebService.userData.Configurations.find(config => config.Code == "AccountStatus2").Value;
      // this.accountStatus3 = + this.authWebService.userData.Configurations.find(config => config.Code == "AccountStatus3").Value;
      // this.keyword.Statuses = [this.accountStatus2, this.accountStatus3];
      this.keyword.Statuses = [this.accountStatus2];
    }
  }


  onNextOrPrevious(page: number = 1) {
    this.loadAccounts(page, this.pageSize);
    this.currentPage = page;
    return page;
  }

  onChange = () => {
    this.loadAccounts(this.utility.page = 1, this.pageSize);
  }

  onSearch = () => {
    if (!this.isSearchable()) {
      this.msg.info("Please provide at least one filter value.", "Carrier Account Search", { timeOut: 5000 });
      return;
    }
    this.setSearchKeywords();
    //console.log('Saved values = ', this.keyword);
    this.utility.page = 1;
    this.message = "Searching for carrier account(s), please wait...";
    this.loadAccounts(this.utility.page, this.pageSize);
  }

  checkKey(event){
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 13) {
      this.onSearch();
      return;
    }
  }

  InitMultiselect() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'desc',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: this.ShowFilter,
      maxHeight: 120,
      closeDropDownOnSelection: false
    };
  }

  onItemSelect(item: any) {
    //console.log('onItemSelect', item);
    //console.log('selectedItems', this.selectedItems);
  }
  onSelectAll(items: any) {
    //console.log('onSelectAll', items);
  }
  toogleShowFilter() {
    this.ShowFilter = !this.ShowFilter;
    this.dropdownSettings = Object.assign({}, this.dropdownSettings, { allowSearchFilter: this.ShowFilter });
  }

  handleLimitSelection() {
    if (this.limitSelection) {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: 2 });
    } else {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: null });
    }
  }

  onDeSelect(item: any) {
    //console.log('onItemSelect', item);
    //console.log('selectedItems', this.selectedItems);
  }

  onReset = () => {
    this.selectedItems = [];
    this.carrierNumber = null;
    this.carrierName = null;
    this.initKeyword();
    this.utility.page = 1;
    ////console.log('Saved values = ', this.keyword);
    this.loadAccounts(this.utility.page, this.pageSize);
  }
  setSearchKeywords = () => {
    this.keyword.AccountNumber = (this.carrierNumber != null) ? this.carrierNumber : "All";
    this.keyword.Suffix = (this.carrierName != null) ? this.carrierName : "All";
    this.keyword.Statuses = (this.selectedItems) ? this.selectedItems.map(status => { return status.id; }) : [];
  }

  initKeyword = () => {
    this.keyword = { Suffix: "All", AccountNumber: "All", Statuses: [] };
    this.retrieveDefaultStatuses();
  }

  isSearchable = () => {
    return (this.carrierNumber != null || this.carrierName != null || this.selectedItems.length > 0);
  }

  onSort(rank: number) {
    this.direction = !this.direction;
    this.rankCtrl = rank;
    //this.onExcuteSort(rank);
    this.loadAccounts(this.utility.page, this.pageSize);
  }

  onResetFlags() {
    this.flags = { flagAN: 1, flagNM: 1, flagLU: 1, flagCT: 1, flagST: 1, flagDS: 1 };
  }

  onExcuteSort(rank: number) {
    this.onResetFlags();
    let sort = (this.direction) ? 3 : 2;
    this.criteria = null;
    switch (rank) {
      case this.ranks.flagAN: {
        this.criteria = this.sortLabels.flagAN;
        this.flags.flagAN = sort;
        break;
      }
      case this.ranks.flagNM: {
        this.criteria = this.sortLabels.flagNM;
        this.flags.flagNM = sort;
        break;
      }
      case this.ranks.flagLU: {
        this.criteria = this.sortLabels.flagLU;
        this.flags.flagLU = sort;
        break;
      }
      case this.ranks.flagCT: {
        this.criteria = this.sortLabels.flagCT;
        this.flags.flagCT = sort;
        break;
      }
      case this.ranks.flagST: {
        this.criteria = this.sortLabels.flagST;
        this.flags.flagST = sort;
        break;
      }
      default: {
        this.criteria = this.sortLabels.flagDS;
        this.flags.flagDS = sort;
        break;
      }
    }

  }

  setApplicationLock(application,lockStatus)
  {
   
    this.carrierService.getById(application.Id).subscribe((carrier:any)=>
    {
      
      application.isLocked =  carrier.isLocked = lockStatus;    
      application.isLockedBy = carrier.isLockedBy = lockStatus? this.authWebService.userData.User.UserName : "";

      this.carrierService.putApplication(carrier).subscribe((r)=>
      {
       
        if(lockStatus)
        {
          this.msg.info("Application Locked By '" + carrier.isLockedBy + "'", "Lock Application", { timeOut: 5000 });
        }
        else
        {
          this.msg.info("Application Unlocked", "UnLock Application", { timeOut: 2000 });
        }
      }, error=>{
       
      });
    });
    
  }

  unLockApplication(data)
  {
    this.setApplicationLock(data,false);
  }

  onProcess = (ctrlAction, data: any) => {
    if(data.status_id!=1){
      this.setApplicationLock(data,true);
    this.ctrlData.ctrlAction = ctrlAction;
    this.utility.currentActive = 2;
    this.ctrlData.data = data;
    this.ctrlData.carrierId = data.Id;
    this.utility.isBtnVisible = false;
    this.utility.permitType = "";
    this.utility.isView = false;
    this.utility.carrierId = data.Id;
    this.utility.carrierName = data.Name;
    //console.log('CarrierId = ', this.utility.carrierId);
    if(!this.processFlag){
      this.utility.carrierObject=this.ctrlData;
      this.router.navigate(['carrier/account/approval',this.utility.carrierId]);
    }

    }
  }

  onViewAccount = (id: number) => {
    ////console.log('Account ID: ', id);
    this.utility.currentActive = 4;
    this.ctrlData.carrierId = id;
    this.utility.isBtnVisible = true;
    this.utility.isView = true;
    this.utility.isCarrier=true;
    this.router.navigate(['/carrier/account/edit/' + id + '/' + 2])
  }



}

